// src/components/Modals/AnswerQuestionModal.js
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

const AnswerQuestionModal = ({ onClose, questionId, question, detail, onAnswerPosted }) => {
  const { currentUser } = useContext(AuthContext);
  const [visible, setVisible] = useState(false);
  const [answer, setAnswer] = useState('');
  const [showOnProfile, setShowOnProfile] = useState(true); // Checkbox is checked by default
  const [error, setError] = useState(null);
  // -- NEW TAGS STATE --
  const [tags, setTags] = useState([])
  const [tagInput, setTagInput] = useState('')

  // Allows you to delete a tag by its index
  const removeTag = idx => {
   setTags(tags.filter((_, i) => i !== idx));
  };

  useEffect(() => {
    console.log("AnswerQuestionModal opened for questionId:", questionId, "with question:", question);
    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer);
  }, [questionId, question]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose(), 600);
  };

  const handleOverlayClick = (event) => {
    if (event.target.classList.contains('modal')) {
      handleClose();
    }
  };

  // When user types a tag and hits Enter
  const handleTagKeyDown = e => {
    // on Enter **or** Spacebar
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const t = tagInput.trim().toLowerCase();
      if (t && !tags.includes(t)) {
        setTags([...tags, t]);
      }
      setTagInput('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!answer.trim()) {
      setError('Answer is required');
      return;
    }

    if (!questionId) {
      setError('Invalid question ID');
      return;
    }

    console.log("Submitting answer:", answer, "with showOnProfile:", showOnProfile);

    const url = `/api/questions/${questionId}/answer`;
    try {
      const res = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          answer, 
          displayOnProfile: showOnProfile, 
          replierName: currentUser ? currentUser.name : 'Anonymous',
          tags,    // ← include whatever pills the user has added
        }),
      });
      const data = await res.json();
      console.log('Response from PUT request:', data);
      console.log('Tip from updated question:', data.tip);

      if (!res.ok) {
        setError(data.message || 'Failed to post answer');
      } else {
        if (onAnswerPosted) onAnswerPosted(data);

        // If the question has a tip, finalize the payment
        if (data.tip && data.tip > 0) {
          const paymentRes = await fetch(`/api/payments/process/${questionId}/finalize-payment`, {
            method: 'POST',
          });
          const paymentData = await paymentRes.json();

          if (paymentRes.ok) {
            console.log('Payment finalized:', paymentData);
          } else {
            console.error('Failed to finalize payment:', paymentData.message);
            setError(paymentData.message || 'Failed to finalize payment');
          }
        }

        handleClose();
      }
    } catch (err) {
      setError('Failed to post answer. Please try again.');
      console.error(err);
    }
  };

  return (
    <div
      className={`modal ${visible ? 'show' : ''}`}
      id="answer-question-modal"
      onClick={handleOverlayClick}
    >
      <div className="card modal-card" onClick={(e) => e.stopPropagation()}>
        <span className="close-modal" onClick={handleClose}>
          <img src="/images/i_modal_close.svg" alt="Close" />
        </span>
        <div className="center">
          <div className="badge-question small dark">
            <div className="badge-question-number small">
              Q
            </div>
          </div>
          <h5 className="margin-top-m">{question}</h5>
        </div>
        <div>
          <p className="large">{detail}</p>
        </div>
        <div className="divider dotted" />
        <form onSubmit={handleSubmit}>
          <div className="text-uppercase margin-top-l">Your answer</div>
          <textarea
            name="answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            required
          />

          {/* -- TAGS INPUT UI -- */}
          <div className="text-uppercase margin-top-l">Tags</div>
          <div className="tags-input">
            {tags.map((t,i) => (
              <span key={i} className="tag">
                {t}
                <button type="button" className="remove-tag" onClick={() => removeTag(i)}>×</button>
              </span>
            ))}
            <input
              className="tag-input"
              type="text"
              value={tagInput}
              onChange={e => setTagInput(e.target.value)}
              onKeyDown={handleTagKeyDown}
            />
          </div>

          {error && <p className="fail">{error}</p>}

          <div className="modal-footer">
            <div className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                id="showOnProfile"
                type="checkbox"
                checked={showOnProfile}
                onChange={(e) => {
                  console.log("Checkbox changed, new value:", e.target.checked);
                  setShowOnProfile(e.target.checked);
                }}
                aria-labelledby="showOnProfileText"
              />
              {/* This text is no longer a label, so clicking it won’t toggle */}
              <p id="showOnProfileText" className="m-0">Show on profile</p>
            </div>
            <button type="submit" data-value="question form">
              Post Answer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnswerQuestionModal;
